import { SearchQueryStringParams } from 'components/search/utils';

export type QueryTypes = {
  DATERANGE?: boolean;
  DISPLAYTERM?: boolean;
};

export function buildQueryTypeForCity(query: SearchQueryStringParams): QueryTypes {
  const hasDisplayTerm = (query?.displayTerm?.length ?? 0) > 0;
  const hasDate = (query?.date?.length ?? 0) > 0;
  const hasDateEnd = (query?.dateEnd?.length ?? 0) > 0;
  return {
    DISPLAYTERM: hasDisplayTerm,
    DATERANGE: hasDate && hasDateEnd,
  };
}
